<template>
  <div>
    <p class="section-title">现有关联</p>
    <div class="tags-container" ref="tagsContainer" @scroll="handleTagsScroll">
      <div class="tags-wrapper">
        <a-tag
          v-for="(item, index) in visibleTags"
          :key="item.typeId || index"
          :bordered="false"
          closable
          @close="tagClosed(item)"
          class="custom-tag"
          :title="item.keyType"
          >{{ truncateText(item.keyType, 20) }}</a-tag
        >
      </div>

      <!-- 加载中指示器 -->
      <div v-if="isLoading" class="loading-indicator">
        <a-spin size="small" />
        <span style="margin-left: 8px">加载中...</span>
      </div>

      <!-- 空状态提示 -->
      <div
        v-if="
          !isLoading && (!keyMod.keyTypeList || keyMod.keyTypeList.length === 0)
        "
        class="empty-state"
      >
        暂无关联标签
      </div>

      <!-- 已加载全部提示 -->
      <div
        v-if="!isLoading && hasLoadedAll && visibleTags.length > 0"
        class="all-loaded-indicator"
      >
        已加载全部标签
      </div>
    </div>

    <p class="section-title" style="margin-top: 20px">新增关联</p>
    <a-row>
      <a-col :span="24" class="mb-24">
        <key-type-tree
          ref="keyTypeTree"
          @checked="keyTypeChecked"
        ></key-type-tree>
      </a-col>
    </a-row>
    <a-row>
      <a-tag v-for="(item, index) in newSelKeyTypeStrs" :key="index">
        {{ item }}
      </a-tag>
    </a-row>

    <a-row style="margin-top: 20px">
      <el-button type="primary" @click="BuildComHandle">确定</el-button>
      <el-button @click="CancleEdit">取消</el-button>
    </a-row>
  </div>
</template>

<script>
import KeyTypeTree from "@/components/Tree/KeyTypeTree.vue";
import { keywordRelRebuild } from "@/api/keyword";
export default {
  components: {
    KeyTypeTree,
  },
  props: {
    keyMod: {
      type: Object,
      default: function () {
        return {};
      },
    },
    clearSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 现有数据保持不变
      visibleTagCount: 40, // 初始显示的标签数量
      isLoading: false, // 加载状态
      hasLoadedAll: false, // 是否已加载全部
      newSelKeyTypeIds: [], // 新增选择的标签ID
      newSelKeyTypeStrs: [], // 新增选择的标签名称
      perCheckeys: [],
    };
  },
  computed: {
    visibleTags() {
      if (!this.keyMod.keyTypeList) {
        return [];
      }
      // 根据visibleTagCount返回相应数量的标签
      return this.keyMod.keyTypeList.slice(0, this.visibleTagCount);
    },
  },
  watch: {
    // 监听keyTypeList变化，重置加载状态
    "keyMod.keyTypeList": {
      handler() {
        this.visibleTagCount = 40;
        this.hasLoadedAll = false;
      },
      deep: true,
    },
  },
  methods: {
    tagClosed(item) {
      // 使用filter方法创建新数组，过滤掉要删除的项
      if (this.keyMod.keyTypeList && Array.isArray(this.keyMod.keyTypeList)) {
        // 由于keyMod是props，在Vue中我们不应该直接修改props
        // 但我们可以重新赋值整个数组，保持响应式
        this.keyMod.keyTypeList = this.keyMod.keyTypeList.filter(
          (tag) => tag.typeId !== item.typeId
        );
      }
      console.log(this.keyMod.keyTypeList);
    },
    // 添加文本截断方法
    truncateText(text, maxLength) {
      if (!text || typeof text !== "string") return "";
      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    },
    // 处理滚动事件
    handleTagsScroll(event) {
      // 如果正在加载中或已加载全部，则不执行操作
      if (this.isLoading || this.hasLoadedAll) {
        return;
      }

      const container = event.target;
      const { scrollTop, scrollHeight, clientHeight } = container;
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      // 当滚动到距离底部20px时触发加载更多
      if (distanceToBottom <= 20) {
        this.loadMoreTags();
      }
    },
    // 加载更多标签
    loadMoreTags() {
      // 检查是否还有更多标签可加载
      if (
        !this.keyMod.keyTypeList ||
        this.visibleTagCount >= this.keyMod.keyTypeList.length
      ) {
        this.hasLoadedAll = true;
        return;
      }

      this.isLoading = true;

      // 模拟加载延迟，实际应用中可能需要从API加载
      setTimeout(() => {
        // 每次加载20个更多标签
        this.visibleTagCount += 20;

        // 检查是否已加载全部
        if (
          this.keyMod.keyTypeList &&
          this.visibleTagCount >= this.keyMod.keyTypeList.length
        ) {
          this.hasLoadedAll = true;
        }

        this.isLoading = false;
      }, 300); // 模拟网络延迟
    },

    keyTypeChecked(keys, info) {
      console.log(keys, info);
      this.newSelKeyTypeIds = keys;
      this.newSelKeyTypeStrs = info.checkedNodes.map((node) => {
        return node.data.props.title;
      });
    },
    clearTreeSelection() {
      this.newSelKeyTypeIds = [];
      this.newSelKeyTypeStrs = [];
      this.$refs["keyTypeTree"].clearAllChecked();
    },
    BuildComHandle() {
      const typeIds = this.keyMod.keyTypeList
        ? this.keyMod.keyTypeList.map((item) => item.typeId)
        : [];
      const mergedTypeIds = [
        ...new Set([...typeIds, ...this.newSelKeyTypeIds]),
      ];
      this.$confirm("此操作将重建关联关系, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          keywordRelRebuild(this.keyMod.id, mergedTypeIds).then((res) => {
            if (res.code == 0) {
              this.$message.success("重建成功");
              this.$emit("BuildComHandle"); // 触发父组件的事件
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    CancleEdit() {
      this.$emit("BuildComHandle");
    },
  },
  mounted() {
    // 初始化时检查是否需要显示加载更多提示
    if (this.keyMod.keyTypeList && this.keyMod.keyTypeList.length <= 20) {
      this.hasLoadedAll = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
  color: #333;
}

.tags-container {
  width: 100%;
  height: 200px; /* 固定高度 */
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 8px;
  background-color: #fafafa;
  overflow-y: auto; /* 添加垂直滚动 */
  position: relative;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-content: flex-start;
}

/* 美化滚动条 */
.tags-container::-webkit-scrollbar {
  width: 6px;
}

.tags-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.tags-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.tags-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.custom-tag {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px 10px;
  margin-bottom: 6px;
}

.empty-state {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

.loading-indicator {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  color: #666;
  font-size: 14px;
}

.all-loaded-indicator {
  width: 100%;
  text-align: center;
  padding: 8px 0;
  color: #999;
  font-size: 12px;
  font-style: italic;
}
</style>